<template>
  <div>
    <div class="orderAmount-container div-layout">
      <module-title title="推广订单总计" />
      <div class="orderAmount-main">
        <el-form class="searchForm" :inline="true" label-position="right" label-width="130px">
          <el-form-item label="姓名：" prop="teacherName">
            <el-input v-model="searchForm.teacherName" name="teacherName" maxlength="10" placeholder="请输入姓名" class="handle-form-input" />
          </el-form-item>
          <el-form-item label="学校名称：" prop="schoolName">
            <el-input v-model="searchForm.schoolName" name="schoolName" placeholder="请输入学校" class="handle-form-input" />
          </el-form-item>
          <el-form-item label="订单号：" prop="orderCode">
            <el-input v-model="searchForm.orderCode" name="orderCode" placeholder="请输入业务订单号" class="handle-form-input" />
          </el-form-item>
          <el-form-item label="支付时间：" prop="time">
            <el-date-picker v-model="time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="datePickerOptions" :clearable="false" />
          </el-form-item>
          <el-form-item label="手机号：" prop="phoneNumber">
            <el-input v-model="searchForm.phoneNumber" name="phoneNumber" oninput="value=value.replace(/[^\d]/g,'')" maxlength="11" placeholder="请输入手机号" class="handle-form-input" @change="changeNumber" />
          </el-form-item>
          <el-form-item label="推广者ID：" prop="spreadCode">
            <el-input v-model="searchForm.spreadCode" name="spreadCode" placeholder="请输入推广者ID" class="handle-form-input" />
          </el-form-item>
          <el-form-item label="购买者账号类型：" prop="authorizationType">
            <el-select v-model="searchForm.authorizationType" name="authorizationType" size="medium" class="handle-form-input">
              <el-option label="全部" value="" />
              <el-option label="个人" value="1" />
              <el-option label="学校" value="2" />
              <el-option label="代理商" value="3" />
            </el-select>
          </el-form-item>
          <el-form-item label="结算状态：" prop="settlementStatus">
            <el-select v-model="searchForm.settlementStatus" name="settlementStatus" size="medium" class="handle-form-input">
              <el-option label="全部" value="" />
              <el-option label="待结算" value="1" />
              <el-option label="可结算" value="2" />
              <el-option label="已结算" value="3" />
            </el-select>
          </el-form-item>
          <el-form-item style="margin-left:15px;">
            <el-button type="primary" size="medium" icon="el-icon-search" @click="handleSearchFilter">
              查询
            </el-button>
            <el-button type="primary" size="medium" icon="el-icon-download" @click="handleExportFilter">
              导出
            </el-button>
          </el-form-item>
        </el-form>
        <div class="table-box">
          <el-table v-loading="listLoading" :data="spreadOrdersList" highlight-current-row element-loading-text="Loading" class="list-table">
            <el-table-column type="index" width="55" align="center" label="序号" />
            <el-table-column label="业务订单号" prop="orderCode" align="center" width="200" />
            <el-table-column label="支付单号" prop="thirdPaymentCode" align="center" width="200" />
            <el-table-column label="推广者ID" prop="spreadCode" align="center" width="200" />
            <el-table-column label="购买者姓名" prop="teacherName" align="center" width="120" />
            <el-table-column label="购买者手机号" prop="teacherPhoneNumber" align="center" width="200" />
            <el-table-column label="购买者区域" prop="areaName" align="center" width="200">
              <template slot-scope="scope">
                {{ scope.row.provinceName }}-{{ scope.row.cityName }}-{{ scope.row.areaName }}
              </template>
            </el-table-column>
            <el-table-column label="购买者学校名称" prop="schoolName" align="center" width="200" />
            <el-table-column label="购买者账号类型" prop="authorizationTypeName" align="center" width="200" />
            <el-table-column label="授权开始时间" prop="authorizationStartTime" align="center" width="200" />
            <el-table-column label="授权结束时间" prop="authorizationEndTime" align="center" width="200" />
            <el-table-column label="授权期限" prop="authorizationTermName" align="center" />
            <el-table-column label="商品名称" prop="productName" align="center" width="200" />
            <el-table-column label="支付时间" prop="paymentFinishTime" align="center" width="200" />
            <el-table-column label="支付渠道" prop="paymentChannelName" align="center" />
            <el-table-column label="售价（元）" prop="productPrice" align="center" width="120" />
            <el-table-column label="折扣" prop="discountRate" align="center" />
            <el-table-column label="实付金额（元）" prop="afterDiscountAmount" align="center" width="120" />
            <el-table-column label="佣金（元）" prop="commissionAmount" align="center" width="200" />
            <el-table-column label="结算状态" prop="settlementStatus" align="center">
              <template slot-scope="scope">
                {{ scope.row.settlementStatus==1 ? '待结算' : scope.row.settlementStatus==2 ?'可结算':'已结算' }}
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="page.total"
            :page.sync="page.pageNum"
            :limit.sync="page.pageSize"
            @pagination="pageCurriculumList"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSpreadOrdersList, exportSpreadOrdersExcel } from '@/api/yzdPlatformManage/promoterManage';
export default {
  data() {
    return {
      time: '',
      searchForm: {
        teacherName: '', // 姓名
        schoolName: '', // 学校名称
        orderCode: '', // 订单号
        orderFinishStartTime: '', // 支付开始时间
        orderFinishEndTime: '', // 支付结束时间
        phoneNumber: '', // 手机号
        spreadCode: '', // 上级推广者ID
        authorizationType: '', // 购买者账号类型
        settlementStatus: ''// 结算状态
      },
      page: { // 分页参数
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      listLoading: false, // 表格刷新loading
      spreadOrdersList: [],
      datePickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.searchForm.orderFinishStartTime = minDate.getTime();
          if (maxDate) {
            this.searchForm.orderFinishStartTime = '';
          }
        },
        disabledDate: (time) => {
          const one = 3 * 30 * 24 * 3600 * 1000;
          const minTime = this.startDate;
          if (this.searchForm.orderFinishStartTime !== '') {
            let maxTime = this.searchForm.orderFinishStartTime + one;
            if (maxTime > new Date()) {
              maxTime = new Date();
            }
            return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now() - 8.64e6;
          } else {
            return time.getTime() > Date.now() - 8.64e6;
          }
        }
      },
      option: {}
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    changeNumber(val) {
      this.searchForm.phoneNumber = val;
    },
    handleSearchFilter() {
      this.page.pageNum = 1;
      this.page.pageSize = 10;
      this.option = {
        teacherName: this.searchForm.teacherName, // 姓名
        schoolName: this.searchForm.schoolName, // 学校名称
        orderCode: this.searchForm.orderCode, // 订单号
        orderFinishStartTime: this.time[0], // 支付开始时间
        orderFinishEndTime: this.time[1], // 支付结束时间
        phoneNumber: this.searchForm.phoneNumber, // 手机号
        spreadCode: this.searchForm.spreadCode, // 上级推广者ID
        authorizationType: this.searchForm.authorizationType, // 购买者账号类型
        settlementStatus: this.searchForm.settlementStatus// 结算状态
      };
      this.getTableList();
    },
    pageCurriculumList(obj) {
      this.page.pageNum = obj.page;
      this.getTableList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.page.pageNum = 1;
      this.page.pageSize = obj.limit;
      this.getTableList();
    },
    // 获取列表
    getTableList() {
      // this.searchForm.orderFinishStartTime = this.time[0];
      // this.searchForm.orderFinishEndTime = this.time[1];
      this.listLoading = true;
      getSpreadOrdersList({ ...this.option, pageNum: this.page.pageNum, pageSize: this.page.pageSize }).then(res => {
        this.listLoading = false;
        if (res.data === null || res.data === '' || res.data === 'undefind') {
          this.spreadOrdersList = [];
          this.page.total = 0;
        } else {
          this.spreadOrdersList = res.data.list;
          this.page.total = res.data.total;
        }
      }).catch(err => {
        // this.$message({ type: 'warning', message: '暂无数据' });
        this.listLoading = false;
        console.log(err);
      });
    },
    // 导出
    handleExportFilter() {
      var op = this.searchForm;
      window.location.href = exportSpreadOrdersExcel(op) ? exportSpreadOrdersExcel(op) : null;
    }
  }
};
</script>
<style lang="scss" scoped>
.table-box{
  padding: 0 30px;
}
</style>

